import { Table, Button, Box } from '@amzn/awsui-components-console';
import { useIntl } from 'react-intl';

import { messages } from './StudentRosterTable.messages';

const StudentRosterTable = ({
    roster,
    onRemoveStudent,
    disableEdits,
    subProvidersArnMap,
    header,
}) => {
    const { formatMessage } = useIntl();
    const columnDefinitions = [
        {
            id: 'firstName',
            header: formatMessage(messages.headerFirstName),
            cell: ({ firstName }) => firstName || '-',
        },
        {
            id: 'lastName',
            header: formatMessage(messages.headerLastName),
            cell: ({ lastName }) => lastName || '-',
        },
        {
            id: 'email',
            header: formatMessage(messages.headerEmail),
            cell: ({ email }) => email || '-',
        },
        {
            id: 'attendance',
            header: formatMessage(messages.headerStudentAttendance),
            cell: ({ hasAcceptedInvitation }) =>
                hasAcceptedInvitation ? formatMessage(messages.studentPresenceField) : '-',
        },
        ...(subProvidersArnMap
            ? [
                  {
                      id: 'provider',
                      header: formatMessage(messages.headerProvider),
                      cell: ({ eKitLicensedProviderArn }) =>
                          subProvidersArnMap[eKitLicensedProviderArn] || '-',
                  },
              ]
            : []),
        {
            id: 'accessControl',
            header: formatMessage(messages.headerAccessControl),
            cell: ({ email, hasAcceptedInvitation }) => (
                <Button
                    disabled={disableEdits}
                    data-testid={`${formatMessage(messages.accessControlButton)}`}
                    onClick={() => onRemoveStudent(email, hasAcceptedInvitation)}
                    variant='normal'
                >
                    {formatMessage(messages.accessControlButton)}
                </Button>
            ),
        },
    ];

    return (
        <Table
            header={header}
            resizableColumns
            variant='container'
            data-testid='student-roster-table'
            wrapLines
            empty={
                <Box textAlign='center'>
                    <Box padding={{ top: 's' }} margin={{ bottom: 'xs' }}>
                        <b>{formatMessage(messages.noClasses)}</b>
                    </Box>
                </Box>
            }
            columnDefinitions={columnDefinitions}
            items={roster}
        />
    );
};

export default StudentRosterTable;
